var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.6667 11.9997H1.33335C0.596969 11.9997 1.52588e-05 11.4027 1.52588e-05 10.6664V1.33303C1.52588e-05 0.596648 0.596969 -0.000305176 1.33335 -0.000305176H10.6667C11.4031 -0.000305176 12 0.596648 12 1.33303V10.6664C12 11.4027 11.4031 11.9997 10.6667 11.9997ZM1.33335 1.33303V10.6664H10.6667V1.33303H1.33335ZM9.33335 9.33303H8.00002V4.66636H9.33335V9.33303ZM6.66668 9.33303H5.33335V2.66636H6.66668V9.33303ZM4.00002 9.33303H2.66668V5.99969H4.00002V9.33303Z",
  fill: "#636766"
})));
export { SvgReports as ReactComponent };
export default __webpack_public_path__ + "d26c9a1ec27299f44b3081b2f8647504.svg";